let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bEFNl")).then(() => parcelRequire('1bpWz'));